// extracted by mini-css-extract-plugin
export var bullet = "_r2-q";
export var bulletText = "_r2-p";
export var bullets = "_r2-k";
export var callout = "_r2-g";
export var calloutBody = "_r2-i";
export var calloutLabel = "_r2-h";
export var checkIcon = "_r2-m";
export var checkList = "_r2-j";
export var checkSvg = "_r2-n";
export var checkText = "_r2-o";
export var fieldCard = "_r2-1";
export var fieldDescription = "_r2-5";
export var fieldHeader = "_r2-3";
export var fieldTitle = "_r2-4";
export var finalNote = "_r2-s";
export var flow = "_r2-x";
export var flowArrow = "_r2-v";
export var flowStep = "_r2-u";
export var helperText = "_r2-r";
export var inlineTitle = "_r2-t";
export var listItem = "_r2-l";
export var noteBody = "_r2-8";
export var noteBodyText = "_r2-9";
export var noteCard = "_r2-2";
export var noteIcon = "_r2-6";
export var noteTitle = "_r2-7";
export var productChoices = "_r2-w";
export var radioDot = "_r2-d";
export var radioDotSelected = "_r2-e";
export var radioDotSvg = "_r2-f";
export var selectableCard = "_r2-b";
export var selectableCardSelected = "_r2-c";
export var strongText = "_r2-a";
export var subHeading = "_r2-0";